import { Box, Typography, Paper, Stack } from "@mui/material";

const StatisticCards = ({ value, title, icon, iconBg, isMainCard }) => {
    return (
        <Paper
            elevation={0}
            sx={{
                p: 2.5,
                borderRadius: 3,
                border: "1px solid",
                borderColor: "divider",
                height: "100%",
                position: 'relative',
                transition: '0.5s',
                userSelect: 'none',
                backgroundColor: isMainCard ? "#F0FDFA" : "#fff",
                '&:hover': {
                    backgroundColor: '#F0FDFA'
                },
            }}
        >
            <Stack direction="row" justifyContent="space-between">
                <Box>
                    <Typography variant="h5" fontWeight={700}>
                        {value}
                    </Typography>

                    <Typography variant="body2" color="text.secondary" mb={0.5}>
                        {title}
                    </Typography>
                </Box>

                <Box
                    sx={{
                        width: 42,
                        height: 42,
                        borderRadius: 2,
                        bgcolor: iconBg,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    {icon}
                </Box>
            </Stack>
        </Paper>
    )
}

export default StatisticCards